const adminRoles = ['admin', 'owner'];

/**
 * Returns true if given role should be considered an 'admin'
 */
export const isAdminRole = (role: string | undefined) =>
  Boolean(role && adminRoles.includes(role));
